import * as constants from './constants';

const INITIAL_STATE = {
    data: [],
    loading: false,
    error: null,
};

export const commodityCategoryDataReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case constants.COMMODITY_CATEGORY_GET:
            return { ...state, loading: true };
        case constants.COMMODITY_CATEGORY_GET_SUCCESS:
            return { ...state, data: action.payload, loading: false };
        case constants.COMMODITY_CATEGORY_GET_ERROR:
            return { ...state, error: action.payload, loading: false };
        case constants.COMMODITY_CATEGORY_STATE_EMPTY:
            return INITIAL_STATE;
        default:
            return state;
    }
};

export const createCommodityCategoryDataReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case constants.COMMODITY_CATEGORY_POST:
            return { ...state, loading: true };
        case constants.COMMODITY_CATEGORY_POST_SUCCESS:
            return { ...state, data: action.payload, loading: false };
        case constants.COMMODITY_CATEGORY_POST_ERROR:
            return { ...state, error: action.payload, loading: false };
        case constants.COMMODITY_CATEGORY_STATE_EMPTY:
            return INITIAL_STATE;
        default:
            return state;
    }
};

export const updateCommodityCategoryDataReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case constants.COMMODITY_CATEGORY_UPDATE:
            return { ...state, loading: true };
        case constants.COMMODITY_CATEGORY_UPDATE_SUCCESS:
            return { ...state, data: action.payload, loading: false };
        case constants.COMMODITY_CATEGORY_UPDATE_ERROR:
            return { ...state, error: action.payload, loading: false };
        case constants.COMMODITY_CATEGORY_STATE_EMPTY:
            return INITIAL_STATE;
        default:
            return state;
    }
};

export const deleteCommodityCategoryDataReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case constants.COMMODITY_CATEGORY_DELETE:
            return { ...state, loading: true };
        case constants.COMMODITY_CATEGORY_DELETE_SUCCESS:
            return { ...state, data: action.payload, loading: false };
        case constants.COMMODITY_CATEGORY_DELETE_ERROR:
            return { ...state, error: action.payload, loading: false };
        case constants.COMMODITY_CATEGORY_STATE_EMPTY:
            return INITIAL_STATE;
        default:
            return state;
    }
};
